import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import reportInfoFragment from '../../fragments/report/reportInfo';

export const sendReportMutation = gql`
  mutation commitReport($report: ReportInput!) {
    commitReport(report: $report) {
      ...reportInfo
    }
  }
  ${reportInfoFragment}
`;

const sendReportOptions = {
  props: ({ ownProps, mutate }) => ({
    commitReport: async (report, author) => {
      return mutate({
        variables: {
          report: {
            ...report,
            content: {
              body: report.content.body,
            },
          },
        },
      });
    },
  }),
};

export default graphql(sendReportMutation, sendReportOptions);
